import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-corporate-wrapper',
  templateUrl: './corporate-wrapper.component.html',
  styleUrls: ['./corporate-wrapper.component.css']
})
export class CorporateWrapperComponent implements OnInit {
  isInspectionDot = false;
  subMenu = 'list';

  constructor(
    private router: Router
  ) {
    const state = this.router.getCurrentNavigation().extras.state;
    if (state && state.isMapper && Boolean(state.isMapper)) {
      this.onSelectSubMenu('mapper');
    }
  }

  ngOnInit() {}

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'mapper') {
      this.isInspectionDot = false;
    }
  }

}
